import { useLocation } from "react-router-dom";
import SLUG_MAP from "./localizedSlugs.json";

export const PUBLIC_LANGS = ["it", "en", "de", "fr", "es", "pl"];

export const SEO_SLUGS = [
  "software-preventivi-cnc",
  "preventivi-officine-meccaniche",
  "calcolo-tempi-lavorazione-cnc",
  "calcolo-costo-lavorazione-cnc",
  "ai-officine-meccaniche",
  "software-tornerie-cnc",
  "software-fresatura-cnc",
  "preventivi-carpenteria-metallica",
  "analisi-disegno-tecnico-ai",
];

export function getLangPrefix(pathname) {
  const seg = (pathname || "").split("/")[1];
  return PUBLIC_LANGS.includes(seg) ? `/${seg}` : "";
}

export function stripLangPrefix(pathname) {
  const prefix = getLangPrefix(pathname);
  if (!prefix) return pathname || "/";
  return pathname.slice(prefix.length) || "/";
}

const PUBLIC_BASES = [
  ...new Set([
    "/blog", "/privacy", "/terms", "/cookies", "/capabilities",
    ...Object.values(SLUG_MAP.capabilitySegment).map((s) => `/${s}`),
    ...Object.values(SLUG_MAP.seo).flatMap((v) => Object.values(v)).map((s) => `/${s}`),
    ...SEO_SLUGS.map((s) => `/${s}`),
  ]),
];

export function isPublicLocalizedPath(pathname) {
  const base = stripLangPrefix(pathname);
  if (base === "/") return true;
  return PUBLIC_BASES.some((b) => base === b || base.startsWith(`${b}/`));
}

export function useLangPrefix() {
  const { pathname } = useLocation();
  return getLangPrefix(pathname);
}
